<template >
    <div class="big-container">
        <div class="container">
            <div class="grid-container">
                <span class="text-span-style"> Assistente </span>
                <div class="grid-card-2" :class="{'grid-card' : dados.status === 0}" @click="redirecionar(dados)" v-for="(dados, index) in dadosDoAssistente" :key="dados.id">
                    <div class="sub-grid-card">
                        <img src="../../../assets/feito.png" alt="Feito" class="card-image" v-if="dados.status === 1">
                        <img src="../../../assets/undone.png" alt="Não feito" class="card-image" v-if="dados.status === 0">
                        <div class="item-sub-grid-card">
                            <span class="title-span"> {{ dados.descricao }} </span>
                            <span>Passo {{ ++index }}</span>
                        </div>
                    </div>
                    <div v-if="dados.status === 0">&gt;</div>
                </div>
                <div class="hide-btn-container">
                    <button class="hide-btn-card" @click="esconderComponente()"> Pular </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Swal from 'sweetalert2';
import _axios from '../../../plugins/axios';
import store from '../../../store';

export default {
    data: () => ({
        dadosDoAssistente : []
    }),

    // created() {
    //     this.verificarConfiguracoes();
    // },

    methods: {

        async verificarConfiguracoes() {
            try {
                this.dadosDoAssistente = await _axios.get('/assistenteConfiguracoes').then((res) => res.data);
                let dadosEmFalta = this.dadosDoAssistente.filter((d) => d.status === 0);
                if (dadosEmFalta.length) {
                    store.state.configuracoes_component = true;
                }
            } catch (error) {
                Swal.fire('warning', 'Ocorreu um erro na tela do assistente!', 'warning');
            }
        },

        redirecionar(dados) {
            if (dados.status === 0) {
                if (dados.url) {
                    this.$router.push(dados.url);
                } else {
                    Swal.fire('Informação', 'Rota não definida!', 'warning');
                }
            }
        },

        esconderComponente() {
            this.$store.state.configuracoes_component = false;
        }
    }
}
</script>
<style scoped>
.big-container {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(196, 195, 195, 0.5);
}
.container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    background-color: #fff;
    border: 0.1px solid #c2c2dd;
    padding: 20px;
    font-size: 12px;
    font-family: sans-serif;
}
.grid-container {
    display: grid;
    grid-template-columns: 1;
    gap: 10px;
}

.grid-card-2 {
    background-color: #efefef;
    border: 0.1px solid #efefef;
    border-radius: 5px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
}

.grid-card .title-span {
    font-weight: bold;
}

.grid-card {
    background-color: #fff;
}

.grid-card:hover {
    background-color: #eaeaec;
    cursor: pointer;
}

.text-span-style {
    font-weight: bold;
}

.card-image {
    display: block;
    width: 35px;
}
img[alt="Não feito"] {
 width: 30px;
}

.sub-grid-card {
    display: flex;
    align-items: center;
}

.item-sub-grid-card {
    margin-left: 10px;
}

.item-sub-grid-card span {
    display: block;
}

.hide-btn-container {
    text-align: right;
}

.hide-btn-card {
    padding: 8px 16px;
    font-size: 14px;
    background-color: #4CAF50;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
</style>
  